/*
 * @Author: wzc
 * @Date: 2024-04-17
 * @LastEditors: wzc
 * 由 findAnalysisItem 获取的分析项主题信息返回的数据，生成最终渲染时需要的 renderThemeList 数组
 * @LastEditTime: 2023-04-17
 * 备注：主要应于 类似于赛果中的【数据分析】主题list；多个主题
 * 【足球世界杯：赛果】
 * 【综合性赛事：赛果|小项数据分析】
 * 【CBA：赛果】
 * 【羽毛球：赛果|晋级之路】
 */

import {
  https_package_getMoreDataByAnalysisID,
  https_package_selectApi,
} from '@api/platfrom_base_api'
export default {
  data() {
    return {
      themeItem: null,
      themeList: null,
      renderThemeList: null,
      isShowAnalysisFlag: true,
    }
  },
  methods: {
    changeSelectToThemeItemHandler(childData) {
      console.debug('changeSelectToThemeItemHandler:', childData)
      // 将修改的参数赋值到 themeList 中
      let curThemeItem = null
      this.themeList = this.themeList.map((themeItem) => {
        if (themeItem.analysisItemId === childData.data.analysisItemId) {
          console.debug('themeItem:', themeItem)
          if (themeItem.inFilter && themeItem.actJson.inFilter) {
            // changeInFilterArr 里面的值是 数字 类型
            const changeInFilterArr = themeItem.actJson.inFilter[
              childData.data.inFilterKey
            ].map((id, index) => {
              if (index === childData.data.indexNo) {
                return childData.data.data - 0
                  ? childData.data.data - 0
                  : childData.data.data
              } else {
                return id
              }
            })
            themeItem.actJson.inFilter[childData.data.inFilterKey] =
              changeInFilterArr
          }
          curThemeItem = themeItem
        }
        return themeItem
      })
      this.changeSelectToThemeItem({
        analysisItemId: curThemeItem.analysisItemId,
        curSelectItem: null,
        filterTypes: curThemeItem.filter.filterTypes,
        actAllSelectObj: curThemeItem.actJson,
      })
    },
    formatFilterAndinFilterLinkage(data) {
      let { analysisItemId, curSelectItem, filterTypes, actAllSelectObj } = data
      console.debug('formatFilterAndinFilterLinkage:', data)
      // 如果 外面的filter与里面的inFilter有联动，则先格式化数据
      if (curSelectItem && ['staticSize'].includes(curSelectItem.name)) {
        this.themeList = this.themeList.map((themeItem) => {
          if (themeItem.analysisItemId === analysisItemId) {
            console.debug(
              'formatFilterAndinFilterLinkage themeItem:',
              themeItem
            )
            if (themeItem.inFilter) {
              const filterTypes = themeItem.inFilter.filterTypes
              const inFilterKey = filterTypes[0].name
              if (themeItem.actJson.inFilter) {
                // changeInFilterArr 里面的值是 数字 类型
                let changeInFilterArr = themeItem.actJson.inFilter[inFilterKey] //statisticalIds
                if (
                  actAllSelectObj[curSelectItem.name] > changeInFilterArr.length
                ) {
                  // 补分析项
                  const addNum =
                    actAllSelectObj[curSelectItem.name] -
                    changeInFilterArr.length
                  let addDoneNum = 0
                  filterTypes[0].values.forEach((selectItem) => {
                    if (
                      !changeInFilterArr.includes(selectItem.value) &&
                      addDoneNum < addNum
                    ) {
                      changeInFilterArr.push(selectItem.value)
                      addDoneNum++
                    }
                  })
                } else if (
                  actAllSelectObj[curSelectItem.name] < changeInFilterArr.length
                ) {
                  // 删除多余的分析项
                  changeInFilterArr.length = actAllSelectObj[curSelectItem.name]
                }
                themeItem.actJson.inFilter[inFilterKey] = changeInFilterArr

                // 将修改后的 inFilter 的 actJson 重新赋值
                actAllSelectObj = JSON.parse(JSON.stringify(themeItem.actJson))
              }
            } else {
              delete themeItem.actJson.inFilter
            }
          }
          return themeItem
        })
      }
      let inFilter_type_api = ''
      if (curSelectItem && ['type'].includes(curSelectItem.name)) {
        this.themeList = this.themeList.map((themeItem) => {
          if (themeItem.analysisItemId === analysisItemId) {
            console.debug(
              'formatFilterAndinFilterLinkage:',
              curSelectItem.name,
              themeItem
            )
            if (themeItem.inFilter) {
              const filterTypes = themeItem.inFilter.filterTypes
              // const inFilterKey = filterTypes[0].name
              filterTypes.forEach((inFilterItem) => {
                if (
                  inFilterItem.dep &&
                  inFilterItem.dep.includes(curSelectItem.name)
                ) {
                  // 如果inFileter多选数组依赖于当前切换的外面下拉时，获取新的内部多选数组，进行更换；再获取新的主题数据
                  // 由于后端filter和inFilter逻辑没有完全解耦，所以这里需要手动修改一个路径将 args 改成 filtertype
                  if (!inFilterItem || !inFilterItem.url) {
                    return console.debug('后端返回缺少url')
                  }
                  const newUrl = inFilterItem.url.replace('args', 'filtertype')
                  inFilter_type_api = `${newUrl}/${themeItem.analysisItemId}/${
                    themeItem.competitionId
                  }/${
                    themeItem.crossSeason ? '0' : themeItem.seasonId
                  }/0/0/0/0/${actAllSelectObj[curSelectItem.name]}`
                }
              })
            }
          }
          return themeItem
        })
      }
      console.debug('inFilter_type_api:', inFilter_type_api)
      return {
        analysisItemId,
        curSelectItem,
        filterTypes,
        actAllSelectObj,
        inFilter_type_api, //只有type切换时，该字段才有值
      }
    },
    async changeSelectToThemeItem(data) {
      const {
        analysisItemId,
        curSelectItem,
        filterTypes,
        actAllSelectObj,
        inFilter_type_api,
      } = this.formatFilterAndinFilterLinkage(data)

      console.debug(
        '改变选择框 11',
        data,
        inFilter_type_api,
        this.findAnalysisItemParams
      )
      // 接受compreSportsMeet_selectThemeContainer组件传来事件，里面有每次切换选择框需要的参数
      // 1、当前选择框改变后，需要重置哪些选择框；
      // 2、找到哪些需要重置的选择框后，根据它自身里面的dep依赖和url来获取新的数据
      // 3、重置完所有新的数据后，要用新的选择框值来加载新的主题数据
      if (inFilter_type_api) {
        await this.getSelectInFilterApi(
          inFilter_type_api,
          analysisItemId,
          'statisticalIds'
        )
        await this.getMoreDataByAnalysisID({
          analysisId: `[${analysisItemId}]`,
          json: `[${JSON.stringify(actAllSelectObj)}]`, //如果该主题需要传参修改inFilter，则json中应该存在inFilter属性，该属性中存储对应要修改的值
          competitionId: this.findAnalysisItemParams.cid, //this.currCid,
          seasonId: this.findAnalysisItemParams.sid, //this.currSid,
          disciplineCode: this.findAnalysisItemParams.did
            ? this.findAnalysisItemParams.did
            : 0,
          eventCode: this.findAnalysisItemParams.eid
            ? this.findAnalysisItemParams.eid
            : 0,
          phaseCode: this.findAnalysisItemParams.pid
            ? this.findAnalysisItemParams.pid
            : 0,
          matchId: this.findAnalysisItemParams.mid
            ? this.findAnalysisItemParams.mid
            : 0,
        })
      } else {
        // 外围下拉框改变时不与inFilter有联动的逻辑走这里
        let clear =
          curSelectItem && curSelectItem.clear ? curSelectItem.clear : []
        let paramsArr = []
        console.debug('clear:', clear, curSelectItem, filterTypes)
        if (clear.length > 0) {
          clear.forEach((clearItem) => {
            let paramsItem = null

            // 将依赖的值push到最后，访问的接口需要
            filterTypes.forEach((selectItem) => {
              if (selectItem.name == clearItem) {
                paramsItem = [
                  analysisItemId,
                  clearItem,
                  selectItem.url,
                  this.findAnalysisItemParams.cid,
                  this.findAnalysisItemParams.sid,
                  this.findAnalysisItemParams.did,
                  this.findAnalysisItemParams.eid,
                  this.findAnalysisItemParams.pid, // pid
                  this.findAnalysisItemParams.mid,
                ]
                if (selectItem.dep.length > 0) {
                  selectItem.dep.forEach((depItem) => {
                    paramsItem.push(actAllSelectObj[depItem])
                  })
                }
              }
            })

            paramsArr.push(paramsItem)
          })
        }

        this.themeAnalysisItemIdArr.forEach((themeAnalysisId, index) => {
          if (themeAnalysisId == analysisItemId) {
            this.jsonArr[index] = JSON.stringify(actAllSelectObj)
          }
        })
        if (curSelectItem && curSelectItem.isMultiple) {
          // 是否将选择框禁止
          let themeList = this.themeList
          themeList.forEach((themeItem) => {
            if (themeItem.analysisItemId === analysisItemId) {
              themeItem.filter.filterTypes.forEach((filterItem) => {
                if (filterItem.name === curSelectItem.name) {
                  filterItem.values.forEach((selectItem) => {
                    if (
                      actAllSelectObj[filterItem.name] &&
                      actAllSelectObj[filterItem.name].length >=
                        filterItem.maxCount &&
                      !actAllSelectObj[filterItem.name].includes(
                        selectItem.value
                      )
                    ) {
                      // 当选中的数量大于等于最大值值时且被选中的值中没有此选项，则禁止被选
                      selectItem.disabled = true
                    } else {
                      selectItem.disabled = false
                    }
                  })
                }
              })
            }
          })
        }

        let isUpdateFlag = true

        if (
          curSelectItem &&
          curSelectItem.minCount &&
          curSelectItem.minCount === curSelectItem.maxCount &&
          actAllSelectObj[curSelectItem.name] &&
          actAllSelectObj[curSelectItem.name].length !== curSelectItem.maxCount
        ) {
          // 必须最少有个值
          // 当只能选固定值时，如果少于则不访问数据，只是选择框变化，不访问接口更新数据
          isUpdateFlag = false
        }
        console.log(
          'curSelectItem:',
          curSelectItem,
          actAllSelectObj,
          isUpdateFlag,
          paramsArr
        )
        if (isUpdateFlag) {
          if (paramsArr.length > 0) {
            for (let i = 0; i < paramsArr.length; i++) {
              const params = paramsArr[i]
              await this.getSelectApi(params)
            }
          }

          console.debug(
            'getMoreDataByAnalysisID:',
            analysisItemId,
            this.jsonArr,
            actAllSelectObj
          )
          await this.getMoreDataByAnalysisID({
            analysisId: `[${analysisItemId}]`,
            json: `[${JSON.stringify(actAllSelectObj)}]`, //如果该主题需要传参修改inFilter，则json中应该存在inFilter属性，该属性中存储对应要修改的值
            competitionId: this.findAnalysisItemParams.cid, //this.currCid,
            seasonId: this.findAnalysisItemParams.sid, //this.currSid,
            disciplineCode: this.findAnalysisItemParams.did
              ? this.findAnalysisItemParams.did
              : 0,
            eventCode: this.findAnalysisItemParams.eid
              ? this.findAnalysisItemParams.eid
              : 0,
            phaseCode: this.findAnalysisItemParams.pid
              ? this.findAnalysisItemParams.pid
              : 0,
            matchId: this.findAnalysisItemParams.mid
              ? this.findAnalysisItemParams.mid
              : 0,
          })
        }
      }
    },
    async getSelectInFilterApi(apiUrl, analysisItemId, jsonOfInfilterKeyName) {
      // 切换主题上面的选择框，获取新的数据接口
      console.debug('apiUrl:', apiUrl)
      console.debug(jsonOfInfilterKeyName)
      const themeObjKey = 'inFilter'
      const new_staticSizeArr = [] //存储新的 staticSize 的值
      await https_package_selectApi(this.axiosBaseUrl, this.$axios, apiUrl)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.renderThemeList = this.renderThemeList.map(
              (theme, themeIndex) => {
                if (
                  theme.analysisItemId == analysisItemId &&
                  theme[themeObjKey]
                ) {
                  theme[themeObjKey].filterTypes = theme[
                    themeObjKey
                  ].filterTypes.map((selectItem) => {
                    if (selectItem.name === jsonOfInfilterKeyName) {
                      console.debug('selectItem:', selectItem, res.data)
                      if (
                        res.data &&
                        res.data.defaultCount &&
                        res.data.defaultCount > 0
                      ) {
                        res.data.values.forEach((item) => {
                          if (
                            new_staticSizeArr.length < res.data.defaultCount
                          ) {
                            new_staticSizeArr.push(item.value)
                          }
                        })
                      }
                      return res.data
                      // selectItem.values = res.data
                      // initSelectId =
                      //   res.data && res.data[0].value ? res.data[0].value : ''
                    } else {
                      return selectItem
                    }
                  })
                  theme.actJson[themeObjKey][jsonOfInfilterKeyName] =
                    new_staticSizeArr
                  this.jsonArr[themeIndex] = JSON.stringify(theme.actJson)
                }
                return theme
              }
            )
            console.debug('renderThemeList:', this.renderThemeList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getSelectApi(allParams) {
      // 切换主题上面的选择框，获取新的数据接口
      console.debug('allParams:', allParams)
      let analysisItemId = allParams[0]
      let selectName = allParams[1]
      let paramsArr = allParams.slice(2)
      let formatParams = []
      paramsArr.forEach((id) => {
        if (
          this.findAnalysisItemParams.sportType === 'compreSportsMeet' ||
          id
        ) {
          formatParams.push(id) //过滤掉0，世界杯和cba没有大小项,did|eid|pid此时等0
        }
      })
      console.debug(selectName, formatParams)
      await https_package_selectApi(
        this.axiosBaseUrl,
        this.$axios,
        formatParams.join('/')
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.renderThemeList = this.renderThemeList.map(
              (theme, themeIndex) => {
                if (theme.analysisItemId == analysisItemId) {
                  let initSelectId = null
                  theme.filter.filterTypes.forEach((selectItem) => {
                    if (selectItem.name == selectName) {
                      selectItem.values = res.data
                      initSelectId =
                        res.data && res.data[0] ? res.data[0].value : '' // value值类型：string|number(0)
                    }
                  })
                  theme.actJson[selectName] = initSelectId
                  this.jsonArr[themeIndex] = JSON.stringify(theme.actJson)
                }
                return theme
              }
            )
            console.debug(this.renderThemeList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    findAnalysisItemResDataToThemeListHandler(resData) {
      const themeAnalysisItemIdArr = []
      const jsonArr = []
      const themeList = resData.map((item) => {
        themeAnalysisItemIdArr.push(item.analysisItemId)
        jsonArr.push(item.json)
        let newItem = JSON.parse(JSON.stringify(item))
        console.debug('newItem:', newItem)
        newItem.actJson = JSON.parse(newItem.json)
        newItem.renderData = null
        if (newItem.analysisItemStyles) {
          // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
          let initAct = newItem.analysisItemStyles.length === 1 ? true : false
          newItem.analysisItemStyles.forEach((styleItem, styleIndex) => {
            if (initAct && styleIndex === 0) {
              styleItem.act = true
            } else {
              styleItem.act = false
            }
          })
        }
        newItem.title2RightName =
          newItem.analysisItemStyles && newItem.analysisItemStyles.length
            ? `${newItem.analysisItemStyles.length}种风格`
            : ''

        // 初始化时是否将选择框禁止
        newItem.filter.filterTypes.forEach((filterItem) => {
          filterItem.values.forEach((selectItem) => {
            if (filterItem.isMultiple) {
              // 当选中的数量大于等于最大值值时且被选中的值中没有此选项，则禁止被选
              // console.debug(
              //   'filterItem:',
              //   filterItem,
              //   newItem.actJson,
              //   newItem.actJson[filterItem.name],
              //   newItem.actJson[filterItem.name].length ===
              //     filterItem.maxCount &&
              //     !newItem.actJson[filterItem.name].includes(
              //       selectItem.value
              //     )
              // )
              if (
                newItem.actJson[filterItem.name] &&
                newItem.actJson[filterItem.name].length ===
                  filterItem.maxCount &&
                !newItem.actJson[filterItem.name].includes(selectItem.value)
              ) {
                selectItem.disabled = true
              } else {
                selectItem.disabled = false
              }
            }
          })
        })

        return newItem
      })
      return [themeList, themeAnalysisItemIdArr, jsonArr]
    },
    refreshCallback() {
      // let json = `[${this.jsonArr.toString()}]`
      // if(this.renderThemeList && this.paramsChangeType === ''){

      // }
      const params = {
        analysisId: `[${this.themeAnalysisItemIdArr.toString()}]`,
        json: `[${this.jsonArr.toString()}]`,
        competitionId: this.findAnalysisItemParams.cid,
        seasonId: this.findAnalysisItemParams.sid,
        disciplineCode: this.findAnalysisItemParams.did,
        eventCode: this.findAnalysisItemParams.eid,
        phaseCode: this.findAnalysisItemParams.pid,
        matchId: this.findAnalysisItemParams.mid,
      }
      this.getMoreDataByAnalysisID(params)
    },
    async getMoreDataByAnalysisID(params) {
      // 根据获取的主题信息，去加载相应的主题数据，这一步完成才能渲染主题
      if (this.pageView === 'posterData') {
        // 数据海报需要加load
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      }
      await https_package_getMoreDataByAnalysisID(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data && res.data.length > 0 && res.data[0]) {
              this.isShowAnalysisFlag = true
              if (this.renderThemeList && this.paramsChangeType === '') {
                // this.renderThemeList 有值且 this.paramsChangeType === '' 时说明，更新数据来自定时刷新数据；如果 this.paramsChangeType 有值则说明数据变化来自参数，那就要走另外的逻辑，全部替换
                console.debug('renderThemeList 1:', this.renderThemeList)
                let renderThemeList = this.renderThemeList
                res.data.forEach((newRenderData) => {
                  renderThemeList.forEach((oldTheme) => {
                    console.debug('oldTheme:', oldTheme)
                    if (
                      oldTheme.analysisItemId == newRenderData.analysisItemId
                    ) {
                      oldTheme.renderData = newRenderData
                      oldTheme.analysisItemName =
                        newRenderData && newRenderData.title
                          ? newRenderData.title
                          : ''
                    }
                  })
                })
                this.renderThemeList = renderThemeList
              } else {
                // 全部更换数
                console.debug('renderThemeList 2:', this.renderThemeList)
                this.renderThemeList = this.themeList.map((theme, index) => {
                  theme.renderData = res.data[index]
                  // console.debug("theme.renderData:", theme.renderData)
                  theme.matchId = this.findAnalysisItemParams.mid
                  theme.sportsId = theme.disciplineId
                  theme.analysisItemName =
                    res.data[index] && res.data[index].title
                      ? res.data[index].title
                      : ''

                  // if (this.pageView !== 'posterData' && theme.inFilter) {
                  //   //  除了数据海报，其他地方暂不要切指标项
                  //   theme.inFilter = null
                  // }
                  return theme
                })
              }

              this.$emit('themeItemRenderDataEvent', {
                themeItem:
                  this.themeList && this.themeList[0]
                    ? this.themeList[0]
                    : null,
              })
            } else {
              this.$emit('themeItemRenderDataEvent', {
                themeItem: null,
              })
              this.isShowAnalysisFlag = false
              this.themeList = []
              this.renderThemeList = []
            }

            this.paramsChangeType = '' //每次数据更新完，重置为''
            console.debug('this.renderThemeList:', this.renderThemeList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })

      if (this.pageView === 'posterData') {
        // 数据海报需要加load
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
    },
  },
}
